import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import {
    SHIKSHA_DEALS_AT_RISK_CONTENT,
    SHIKSHA_DEALS_AT_RISK_ITEMS,
    SHIKSHA_DEALS_AT_RISK_UI,
} from '../constants/shiksha-dashboard.constants'
import { IShikshaDealsAtRiskItem } from '@features/home/models/shiksha-dashboard.model'
import { ShikshaDashboardSubtitleHeaderComponent } from '../shiksha-dashboard-subtitle-header/shiksha-dashboard-subtitle-header.component'

@Component({
    selector: 'app-shiksha-deals-at-risk',
    standalone: true,
    templateUrl: './shiksha-deals-at-risk.component.html',
    styleUrl: './shiksha-deals-at-risk.component.scss',
    imports: [ShikshaDashboardSubtitleHeaderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShikshaDealsAtRiskComponent {
    readonly content = SHIKSHA_DEALS_AT_RISK_CONTENT
    readonly uiConfig = SHIKSHA_DEALS_AT_RISK_UI
    readonly items = input<readonly IShikshaDealsAtRiskItem[]>(SHIKSHA_DEALS_AT_RISK_ITEMS)
    readonly hasItems = computed(() => this.items().length > 0)
}
